import { render, staticRenderFns } from "./roadFetch.vue?vue&type=template&id=b7b84bc4&scoped=true"
import script from "./roadFetch.vue?vue&type=script&lang=js"
export * from "./roadFetch.vue?vue&type=script&lang=js"
import style0 from "./roadFetch.vue?vue&type=style&index=0&id=b7b84bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b84bc4",
  null
  
)

export default component.exports